import api from './api';

export enum UserType {
    JOB_SEEKER = 'JOB_SEEKER',
    HIRING_MANAGER = 'HIRING_MANAGER'
}

export enum DocType {
    TERMS = 'TERMS',
    PRIVACY = 'PRIVACY'
}

export const getLegalContent = async (type: UserType, docType: DocType) => {
    const response = await api.get('/legal-content', {
        params: { type, docType },
    });
    return response.data;
};

export const upsertLegalContent = async (type: UserType, docType: DocType, content: string) => {
    const response = await api.post('/legal-content', {
        type,
        docType,
        content,
    });
    return response.data;
};
